import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface WarningIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const WarningIcon: React.FC<WarningIconProps> = ({ className, style }) => {
  return (
    <ExclamationTriangleIcon 
      className={className} 
      style={style}
    />
  );
};

export default WarningIcon;
